<ion-button (click)="goBack()">
  <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
</ion-button>
